/**
 * @generated SignedSource<<12226b483bbbd75d209f0678d0e864b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditor_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_data">;
  readonly " $fragmentType": "RoomRatesTableRateEditor_data";
};
export type RoomRatesTableRateEditor_data$key = {
  readonly " $data"?: RoomRatesTableRateEditor_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditor_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditorForm_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "631de5d86c444c590ea9cbd2a92e444a";

export default node;
